module.exports = __webpack_public_path__ + "static/media/logo.a21289ed.svg";